import {observer} from "mobx-react";
import {CollapseIndicatorBox} from "../../../../basic-components/collapse-indicator/collapse-indicator.box";
import {AccordionHeaderBox} from "./boxes/accordion-header.box";

interface AccordionHeaderProps {
    title?: React.ReactElement;
    isOpen: boolean;
    isTitleCentered: boolean;
    toggleIsOpen: () => void;
}
export const AccordionHeaderComponent: React.FC<AccordionHeaderProps> = observer((props) => {
    return (
        <AccordionHeaderBox isTitleCentered={props.isTitleCentered} onClick={props.toggleIsOpen}>
            {props.title}
            <CollapseIndicatorBox isOpen={props.isOpen} />
        </AccordionHeaderBox>
    )
})